import { render, staticRenderFns } from "./relatorioSimuladorDePropostas.vue?vue&type=template&id=29db7b90"
import script from "./relatorioSimuladorDePropostas.vue?vue&type=script&lang=js"
export * from "./relatorioSimuladorDePropostas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports